import axios from 'axios'

class CostCenterNumbersQueries {
    fetchCostCenterNumbers(queryString = '') {
        const url = `/finances/finances/cost-center-numbers${queryString ? `?${queryString}` : ''}`
        return axios.get(url)
    }

    updateCostCenterNumber(payload) {
        return axios.patch(`/finances/finances/cost-center-numbers/${payload.id}`, payload)
    }

    syncCostCenterNumbers() {
        return axios.post('/finances/finances/cost-center-numbers-sync')
    }
}

export default new CostCenterNumbersQueries()
